export const baseUrl = 'https://api.themoviedb.org/3'
export const API_KEY = '80133a8730bcdc0232c521e54d3007aa'
export const imageUrl = 'https://image.tmdb.org/t/p/original'
